import Tabs from '@common_components/buttons/Tabs.component';
import IconsGallery from '@common_components/icons/_IconsGallery';
import BottomBar from '@common_components/layout/bottomBar.component';
import HomeLeftBar from '@common_components/layout/LeftBarManager';
import TopBar from '@common_components/layout/topBar.component';
import SvgGallery from '@common_components/svg/_SVGsGallery';
import { Client, CommonSVGsGallery, CommonIconsGallery } from '@umanforge/common';
import { useState } from 'react';

// --- Enum et données ---
enum TabKey {
  COMMON_SVGS = 'common_svgs',
  COMMON_ICONS = 'common_icons',
  FLASHMEETING_SVGS = 'fm_svgs',
  FLASHMEETING_ICONS = 'fm_icons',
}

type TabDefinition = {
  key: TabKey;
  tab: { id: string; name: string };
};

const tabDefinitions: TabDefinition[] = [
  { key: TabKey.COMMON_SVGS, tab: { id: TabKey.COMMON_SVGS, name: 'Common SVGs' } },
  { key: TabKey.COMMON_ICONS, tab: { id: TabKey.COMMON_ICONS, name: 'Common Icons' } },
  { key: TabKey.FLASHMEETING_SVGS, tab: { id: TabKey.FLASHMEETING_SVGS, name: 'Flash Meeting SVGs' } },
  { key: TabKey.FLASHMEETING_ICONS, tab: { id: TabKey.FLASHMEETING_ICONS, name: 'Flash Meeting Icons' } },
];

const tabContentMap: Record<TabKey, React.ReactNode> = {
  [ TabKey.COMMON_SVGS ]: <CommonSVGsGallery />,
  [ TabKey.COMMON_ICONS ]: <CommonIconsGallery />,
  [ TabKey.FLASHMEETING_SVGS ]: <SvgGallery />,
  [ TabKey.FLASHMEETING_ICONS ]: <IconsGallery />,
};

const clients: Client[] = [
  {
    id: '967e5771-db29-4ba3-a71c-ba7543ebaa60',
    name: 'SVG and Icon Gallery for Developers',
  },
];

const GalleryView: React.FC = () => {
  const [ selectedTabKey, setSelectedTabKey ] = useState<TabKey>( TabKey.COMMON_SVGS );

  const handleTabSelect = ( index: number ) => {
    const selectedDef = tabDefinitions[ index ];
    if ( selectedDef ) {setSelectedTabKey( selectedDef.key );}
  };

  return (
    <div className='flex min-h-screen w-screen bg-white-base text-black relative'>
      <HomeLeftBar variant='basic' />
      <div className='w-full pr-10 ml-32 relative'>
        <TopBar clients={clients} onChange={() => {return console.log( 'nothing' );}} />
        <Tabs
          items={tabDefinitions.map( def => {return def.tab;} )}
          activeItem={tabDefinitions.findIndex( def => {return def.key === selectedTabKey;} )}
          onItemClick={handleTabSelect}
        />
        <div className='relative h-full flex pb-20'>
          <div className='py-5 w-full px-7 gap-y-4 h-full overflow-scroll flex flex-col rounded-md shadow-md font-texte'>
            {tabContentMap[ selectedTabKey ]}
          </div>
        </div>
      </div>
      <BottomBar />
    </div>
  );
};

export default GalleryView;
